import React, { useState, useRef, useEffect } from 'react';
import styles from './RefinedTextSegment.module.css';

const RefinedTextSegment = ({ tagType, content, reason, icon }) => {
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef(null);

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsVisible(true);
    };

    const handleMouseLeave = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            setIsVisible(false);
        }, 100);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const tagClass = {
        'emphasis': styles.tagEmphasis,
        'pause': styles.tagPause,
        'remove': styles.tagRemove,
        'structure': styles.tagStructure,
    }[tagType];

    return (
        <span 
            className={styles.container}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <span className={`${styles.tag} ${tagClass}`}>
                {icon}
                {content}
            </span>
            {isVisible && (
                <span className={styles.reasonPopup}>
                    {reason}
                </span>
            )}
        </span>
    );
};

export default RefinedTextSegment;